import { gql } from '@apollo/client'

export default gql`
  mutation SortBanks($ids: [ID]!) {
    sortBanks(ids: $ids) {
      id
      sortOrder
    }
  }
`
